var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "post-box-meta" }, [
    _c("ul", { staticClass: "post-meta" }, [
      _vm.content.date
        ? _c("li", { staticClass: "post-meta__item" }, [
            _c("span", { staticClass: "post-meta__date" }, [
              _vm._v(_vm._s(_vm.content.date))
            ])
          ])
        : _vm._e(),
      _vm.content.time
        ? _c("li", { staticClass: "post-meta__item" }, [
            _c("span", { staticClass: "post-meta__time" }, [
              _c(
                "svg",
                {
                  staticClass: "post-meta__icon",
                  attrs: { width: "12", height: "12", viewBox: "0 0 12 12" }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M6.4 5.9V2.2c0-.2-.2-.4-.4-.4s-.4.2-.4.4v4c0 .1.1.1.1.2L8.4 9c.1.1.2.1.3.1.1 0 .2 0 .3-.1.2-.2.2-.4 0-.6L6.4 5.9z"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M6 0C2.7 0 0 2.7 0 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 11.3C3.1 11.3.7 9 .7 6S3.1.6 6.1.6c3 0 5.3 2.4 5.3 5.4-.1 3-2.4 5.3-5.4 5.3z"
                    }
                  })
                ]
              ),
              _c("span", { staticClass: "post-meta__item-text" }, [
                _vm._v(_vm._s(_vm.content.time))
              ])
            ])
          ])
        : _vm._e(),
      _vm.content.tags
        ? _c("li", { staticClass: "post-meta__item" }, [
            _vm.content.tags && _vm.content.tags.length
              ? _c(
                  "ul",
                  { staticClass: "tag-list" },
                  _vm._l(_vm.content.tags, function(item) {
                    return _c(
                      "li",
                      { staticClass: "tag-list__item" },
                      [
                        item.link
                          ? _c(
                              "nuxt-link",
                              {
                                staticClass: "tag-list__tag",
                                attrs: { to: "/" + item.link }
                              },
                              [_vm._v(_vm._s(item.title))]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e()
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bbf30a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bbf30a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PostMeta.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6bbf30a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PostMeta.vue
// module chunks = 0 1 2